import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  canOnboard,
  canChatView,
  canViewSummary,
  isEnterpriseAiOwner,
  isTenantAdmin,
  isPlatformAdmin,
} from "../utils/entitlements";

export const GuardedUserRoute = () => {
  const { authenticated, initialized } = useAuth();
  if (!initialized && !authenticated) return <div>Loading...</div>;
  return authenticated ? <Outlet /> : <Navigate to="/" replace />;
};

/** Team members — tenant-admin (invite) or EAO (project assign) or platform-admin */
export const GuardedAdminRoute = () => {
  const { authenticated, initialized, user } = useAuth();
  if (!initialized && !authenticated) return <div>Loading...</div>;
  if (!authenticated) return <Navigate to="/" replace />;
  const roles = user?.roles || [];
  const canManageTeam =
    isTenantAdmin(roles) || isEnterpriseAiOwner(roles) || isPlatformAdmin(roles);
  return canManageTeam ? <Outlet /> : <Navigate to="/projects" replace />;
};

export const GuardedSuperAdminRoute = () => {
  const { authenticated, initialized, user } = useAuth();
  if (!initialized && !authenticated) return <div>Loading...</div>;
  if (!authenticated) return <Navigate to="/" replace />;
  return isPlatformAdmin(user?.roles) ? <Outlet /> : <Navigate to="/projects" replace />;
};

/** Client admin console — tenant-admin (user mgmt); EAO / platform may access */
export const GuardedClientAdminRoute = () => {
  const { authenticated, initialized, user } = useAuth();
  if (!initialized && !authenticated) return <div>Loading...</div>;
  if (!authenticated) return <Navigate to="/" replace />;
  const roles = user?.roles || [];
  return (isTenantAdmin(roles) || isEnterpriseAiOwner(roles) || isPlatformAdmin(roles))
    ? <Outlet />
    : <Navigate to="/projects" replace />;
};

/** Gate 0 onboard / framework config write */
export const GuardedOnboardRoute = () => {
  const { authenticated, initialized, user } = useAuth();
  if (!initialized && !authenticated) return <div>Loading...</div>;
  if (!authenticated) return <Navigate to="/" replace />;
  return canOnboard(user?.roles) ? <Outlet /> : <Navigate to="/projects" replace />;
};

/** Chat page — requires chat view (write roles only in Phase 1 matrix) */
export const GuardedChatRoute = () => {
  const { authenticated, initialized, user } = useAuth();
  if (!initialized && !authenticated) return <div>Loading...</div>;
  if (!authenticated) return <Navigate to="/" replace />;
  const roles = user?.roles || [];
  if (canChatView(roles)) return <Outlet />;
  // Reviewers: send to summary if they somehow hit /chat/:id
  const path = window.location.pathname;
  const m = path.match(/^\/chat\/([^/]+)/);
  if (m && canViewSummary(roles)) {
    return <Navigate to={`/summary/${m[1]}`} replace />;
  }
  return <Navigate to="/projects" replace />;
};

/** Summary — any role with summary view */
export const GuardedSummaryRoute = () => {
  const { authenticated, initialized, user } = useAuth();
  if (!initialized && !authenticated) return <div>Loading...</div>;
  if (!authenticated) return <Navigate to="/" replace />;
  return canViewSummary(user?.roles) ? <Outlet /> : <Navigate to="/projects" replace />;
};
